import React, { useContext } from 'react'
import { Outlet } from 'react-router-dom'

import { Profile } from '.'
import PageOverlayBusy from '../components/page-overlay/page-overlay-busy'
import { MetadataContext } from '../store/metadata-context-provider'
import { UserContext } from '../store/user-context-provider'

const Layout = () => {
  const { userProfile, userProfileIsLoading } = useContext(UserContext)
  const { isLoading: metadataIsLoading } = useContext(MetadataContext)

  // if either the profile or the metadata is loading, display the
  // busy page
  if (userProfileIsLoading || metadataIsLoading) return <PageOverlayBusy />

  // Once loaded, evaluate if we have a profile or not.  If no profile
  // found, display the profile component.
  if (!userProfile || userProfile.length !== 1) return <Profile />

  // If we pass both checks we can render the application
  return <Outlet />
}

export default Layout
